var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location-map-component" }, [
    _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        {
          staticClass: "details-container",
          class: { visible: _vm.selectedLocation }
        },
        [
          _c("div", { staticClass: "details-box bg-white" }, [
            _vm.selectedLocation != null
              ? _c("div", { staticClass: "content" }, [
                  _vm.selectedLocation.top_title
                    ? _c("div", {
                        staticClass: "top-title",
                        domProps: {
                          innerHTML: _vm._s(_vm.selectedLocation.top_title)
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedLocation.title
                    ? _c("h2", {
                        staticClass: "title",
                        domProps: {
                          innerHTML: _vm._s(_vm.selectedLocation.title)
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedLocation.copy
                    ? _c("div", {
                        staticClass: "copy",
                        domProps: {
                          innerHTML: _vm._s(_vm.selectedLocation.copy)
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedLocation.button
                    ? _c("div", { staticClass: "button-container" }, [
                        _c("a", {
                          staticClass: "hover-button orange",
                          attrs: {
                            href: _vm.selectedLocation.button.url,
                            target: _vm.selectedLocation.button.target
                          },
                          domProps: {
                            innerHTML: _vm._s(_vm.selectedLocation.button.title)
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "mapContainer",
          staticClass: "map-container",
          class: { "details-visible": _vm.selectedLocation }
        },
        [_vm._t("map")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }